<template>
  <v-app 
    ref="AppRef"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
      up: () => swipe('Up'),
      down: () => swipe('Down')
    }"
  >
    
    <!-- loader da pagina -->
    <v-overlay :value="appLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <router-view 
      v-if="this.$router.currentRoute.name == 'Site' || this.$router.currentRoute.name == 'Política de Privacidade'"
    />

    <div v-else>
      <Header
        ref="appHeader"
      />
    </div>

  <!-- container principal - tela central -->
    <v-main v-if="this.$router.currentRoute.name != 'Site' && this.$router.currentRoute.name != 'Política de Privacidade'">
      <v-container fluid class="fill-height d-flex flex-column">

        <!-- aviso para conta que está expirando -->
        <v-alert
          type="warning"
          elevation="2"
          dismissible
          class="mt-2"
          v-if="loggedUser && loggedUser.isExpired"
        >
          A sua conta AgroSim <b>expirou!</b> 
          {{loggedUser.expirationDays > 0 ? 'Você tem uma tolerância de apenas mais ' + loggedUser.expirationDays + ' dia' + (loggedUser.expirationDays > 1 ? 's' : '') + ' de acesso restante.' : '' }}
          {{loggedUser.expirationDays == 0 ? 'Hoje é o seu último dia de telerância para acessar o sistema.' : '' }}
          {{loggedUser.expirationDays < 0 ? 'Seu acesso ao sistema será bloqueado.' : '' }}
          <br>
          Entre em contato URGENTE com a equipe AgroSim para manter sua conta ativa e não perder o acesso a plataforma.
        </v-alert>

        <!-- este componente vai carregar a página no centro da tela de acordo com o path -->
        <router-view />
      </v-container>

    </v-main>


    <!-- menu inferior para mobile -->
    <v-bottom-navigation 
      v-model="value" 
      :app="$vuetify.breakpoint.smAndDown"
      shift
      color="#164b3e"
      style="background-color: #37bc9b;"
      dark
      :input-value="$vuetify.breakpoint.smAndDown"
      class="d-md-none"
      v-if="this.$router.currentRoute.name != 'Site' && this.$router.currentRoute.name != 'Política de Privacidade' && loggedUser.accountId != 1"
    >
      <v-btn value="" class="d-none">
      </v-btn>

      <template v-if="this.loggedUser.isAltavenda">
        <v-btn value="/app/sale_orders" to="/app/sale_orders">
          <span>Pedidos</span>
          
          <v-icon>mdi-handshake</v-icon>
          <!-- Colocar agendas, tarefas, tabela de preco produto -->
        </v-btn>
      </template>
      <template v-else>

        <v-btn value="/app/execution_operations" to="/app/execution_operations">
          <span>Operações</span>
          
          <v-icon>mdi-tractor</v-icon>
        </v-btn>
        
        <v-btn value="/app/purchases" to="/app/purchases">
          <span>Compras</span>
          
          <v-icon>mdi-cart</v-icon>
        </v-btn>
        
        <v-btn value="/app/sales" to="/app/sales">
          <span>Vendas</span>
          
          <v-icon>mdi-handshake</v-icon>
        </v-btn>
        
        <v-btn value="/app/cash_book" to="/app/cash_book">
          <span>Financeiro</span>
          
          <v-icon>mdi-chart-bar</v-icon>
        </v-btn>
      </template>
        
    </v-bottom-navigation>

  </v-app>

</template>

<script>

import Header from '../components/shared/header.vue';
import gql from 'graphql-tag';

export default {
  name: 'AppName',
  data() {
    return {
      left: false,
      // currentPageTitle: "",
      appLoading: false,
      loggedUser: {},
      value: null
    }
  },
  components: {
    // 'NavigationMenu' : NavigationMenu,
    'Header': Header
  },
  watch: {
    '$route': {
      handler: function(to, from) {
        // console.log("to", to, "from", from);  
        this.value = to.path;
      
        // this.currentPageTitle = to.meta.title || ""
      },
      immediate: true,
      deep: true
    }
  },
  created() {    
    console.log("RODANDO no APP", this.$router.currentRoute.name);
    if (this.$router.currentRoute.name != "Site" && this.$router.currentRoute.name != 'Política de Privacidade') {
      this.appLoading = true;
      this.getCurrentUser(user => {
        this.loggedUser = user;
        if (user) {
          // console.log("USER", user);
          this.appLoading = false;
        }
      });
    }
  },
  methods: {
    swipe (direction) {
      // utilizado para dar aquele swipe da esquerda para direita no mobile pra abrir o menu
      if (direction == "Right") {
        if (this.$refs.appHeader) {
          this.$refs.appHeader.openMenuApp();
        }
      }
      // console.log(direction);
    },
  },
}

</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  /* overflow-x: hidden; */
}


/* #app {
  background-color: #0c0c0c !important;
 } */
</style>
